import { Component, OnInit } from '@angular/core';
import { OwnerTabsService, Tab } from '../../services/owner-tabs.service';
import { CommonModule } from '@angular/common';
import { OverviewComponent } from '../owner-tabs-Components/overview/overview';
import { MyPropertiesComponent } from '../owner-tabs-Components/my-properties/my-properties';
import { RequestsOffersComponent } from '../owner-tabs-Components/requests-offers/requests-offers';
import { AnalyticsComponent } from '../owner-tabs-Components/analytics/analytics';
import { FinancialComponent } from '../owner-tabs-Components/financial/financial';
import { ManageTicketsComponent } from '../../../developer/Components/tickets/manage-tickets.component';
import { Marketing } from '../../../broker/Components/broker-tabs-Components/marketing/marketing';

@Component({
  selector: 'app-owner-tabs-content',
  standalone: true,
  imports: [
    CommonModule,
    OverviewComponent,
    MyPropertiesComponent,
    RequestsOffersComponent,
    AnalyticsComponent,
    FinancialComponent,
    ManageTicketsComponent,
    Marketing,
  ],
  templateUrl: './owner-tabs-content.html',
  styleUrl: './owner-tabs-content.scss',
})
export class OwnerTabsContent implements OnInit {
  activeTab: string = '';
  tabs: Tab[] = [];
  profileComponent: any = null;

  constructor(private tabsService: OwnerTabsService) { }

  ngOnInit(): void {
    this.tabs = this.tabsService.getTabs();
    this.activeTab = this.tabsService.getActiveTab();
    this.ensureProfileComponentLoaded(this.activeTab);

    this.tabsService.activeTab$.subscribe((tabId) => {
      this.activeTab = tabId;
      this.ensureProfileComponentLoaded(tabId);
    });
  }

  private ensureProfileComponentLoaded(tabId: string): void {
    if (tabId !== 'profile' || this.profileComponent) return;
    import('../owner-tabs-Components/profile/profile').then((m) => {
      this.profileComponent = m.OwnerProfileComponent;
    });
  }

  isActiveTab(tabId: string): boolean {
    return this.activeTab === tabId;
  }

  getComponentForTab(tabId: string): any {
    // Import components dynamically based on tab ID
    switch (tabId) {
      case 'overview':
        return import('../owner-tabs-Components/overview/overview').then(
          (m) => m.OverviewComponent,
        );
      case 'my-properties':
        return import('../owner-tabs-Components/my-properties/my-properties').then(
          (m) => m.MyPropertiesComponent,
        );
      case 'profile':
        return import('../owner-tabs-Components/profile/profile').then(
          (m) => m.OwnerProfileComponent,
        );
      case 'requests-offers':
        return import('../owner-tabs-Components/requests-offers/requests-offers').then(
          (m) => m.RequestsOffersComponent,
        );
      case 'analytics':
        return import('../owner-tabs-Components/analytics/analytics').then(
          (m) => m.AnalyticsComponent,
        );
      case 'marketing':
        return import('../../../broker/Components/broker-tabs-Components/marketing/marketing').then(
          (m) => m.Marketing,
        );
      case 'financial':
        return import('../owner-tabs-Components/financial/financial').then(
          (m) => m.FinancialComponent,
        );
      case 'tickets':
        return import('../../../developer/Components/tickets/manage-tickets.component').then(
          (m) => m.ManageTicketsComponent,
        );
      default:
        return null;
    }
  }
}
